module.exports = __webpack_public_path__ + "static/media/nikola-nedeljkovic.41ec46c1.jpg";